
var weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function getDayName(date) {
    var dateVal = new Date(date);
    var index = dateVal.getDay();
    return weekDays[index];
}

function getMonthName(date) {
    var dateVal = new Date(date);
    var index = dateVal.getMonth();
    return months[index];
}

function convertToFormattedDate(date) {
    // format "Tuesday, Feb 9 2021"
    var tempDate = new Date(date);
    return getDayName(tempDate) + ", "+ getMonthName(tempDate) + " " + tempDate.getDate() + " " + tempDate.getFullYear();
}

export { getDayName, getMonthName, convertToFormattedDate }


// WEBPACK FOOTER //
// ./src/app/main/shared/utils/dateUtils.ts